module.exports = __webpack_public_path__ + "img/calendar-plus.f92d5bab.svg";